var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudentTransfer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8887 7.11133H7.11089C5.88359 7.11133 4.88867 8.24838 4.88867 9.65101V22.3494C4.88867 23.7521 5.88359 24.8891 7.11089 24.8891H24.8887C26.116 24.8891 27.1109 23.7521 27.1109 22.3494V9.65101C27.1109 8.24838 26.116 7.11133 24.8887 7.11133Z",
    stroke: "#D68100",
    strokeWidth: 2.22222,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1111 11.5558L22.6666 11.5558L22.6666 17.1113",
    stroke: "#D68100",
    strokeWidth: 2.22222,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4523 12.3417C23.8862 11.9077 23.8862 11.2042 23.4523 10.7703C23.0184 10.3364 22.3149 10.3364 21.881 10.7703L23.4523 12.3417ZM15.2143 17.437L14.4286 18.2227L16 19.794L16.7856 19.0083L15.2143 17.437ZM21.881 10.7703L15.2143 17.437L16.7856 19.0083L23.4523 12.3417L21.881 10.7703Z",
    fill: "#D68100"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentTransfer);
export default __webpack_public_path__ + "static/media/student-transfer.af6d0651502b50285c3d274adb47ee6a.svg";
export { ForwardRef as ReactComponent };